import script from "./SportHighlights.vue?vue&type=script&setup=true&lang=js"
export * from "./SportHighlights.vue?vue&type=script&setup=true&lang=js"

import "./SportHighlights.vue?vue&type=style&index=0&id=979d1ede&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-979d1ede"]])

export default __exports__